import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import {
  ButtonSendTheme,
  DropDownTheme,
  SearchBarTheme,
  TableListTheme,
} from "@/styles/mui/tableListTheme";
import { ThemeProvider } from "@mui/material/styles";

//Mui
import DateSelection from "@/components/dateSelection";
import DownloadIcon from "@mui/icons-material/Download";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";

// Navigate
import { useLocation, useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import { SearchingBar } from "@/components/DataTable/searchingBar";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch
import { getAllCustomer } from "@/fetch/fetchCustomer";
import { getGiveawayList, getGiveawayMasterItems } from "@/fetch/fetchGiveaway";

// Config
import { CustomerTableColumn } from "@/config/tableColumnConfig";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";
import { useSelector } from "react-redux";

//import generate csv library
import { useCurrentAction } from "@/hooks/user";
import { CSVLink } from "react-csv";

const CustomerManagePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const navigate = useNavigate();
  //get the state from the imcoming roue and store into useState as initital Value
  const location = useLocation();
  const { pathname } = location;

  const defaultStartDate = moment().startOf("month");
  const defaultEndDate = moment().endOf("month");
  //create a Ref to store customerData as reference
  const customerDataRef = React.useRef([]);

  // States
  const [customerData, setCustomerData] = React.useState([]);

  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [csvDataItem, setCsvDataItem] = React.useState([]);
  const [brandName, setBrandName] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [criteria, setCriteria] = React.useState(
    location.state?.criteria || {
      brand: null,
      product: null,
      staffCode: null,
    }
  );
  const [tablePage, setTablePage] = React.useState(
    location.state?.tablePage || 0
  );

  // create a headers for generate csv file
  const headers = [
    { label: "Customer Full Name", key: "fullname" },
    { label: "Customer Phone", key: "phone" },
    { label: "Customer OptOut", key: "opt_out" },
    { label: "Staff Code", key: "staff_code" },
    { label: "Staff Name", key: "staff_name" },
    { label: "Giveaway Invoice Id", key: "giveaway_invoice_id" },
    { label: "Giveaway Invoiceitem Qty", key: "giveaway_invoiceitem_qty" },
    {
      label: "Giveaway Invoiceitem Types Name",
      key: "giveaway_invoiceitem_types_name",
    },
    { label: "Invoice Id", key: "invoice_id" },
    { label: "Invoiceitem Id", key: "invoiceitem_id" },
    { label: "Item Brand", key: "item_brand" },
    { label: "Item Name", key: "item_name" },
    { label: "M18 code", key: "m18_product_code" },
    { label: "Master Item Id", key: "master_item_id" },
    { label: "Time Created", key: "time_created" },
    { label: "Types Id", key: "types_id" },
  ];

  const onCellClick = (data) => {
    let tempData;

    if (data) {
      for (let i = 0; i < customerData.length; i++) {
        if (customerData[i].id === data.id) {
          tempData = customerData[i];
        }
      }
      //store criteria value and tablepage value into route state
      navigate(`view/${data.id}`, {
        state: {
          customerData: tempData,
          criteria,
          tablePage,
        },
      });
    }
  };

  //create function to call api and retrieve giveaway item data with specific criteria to gerenate CSV file
  const fetchGiveawayList = async (criteria) => {
    await getGiveawayList(criteria, startDate, endDate).then((data) => {
      if (data && data.results) {
        setCsvDataItem(data.data);
        mergeData();
      } else {
        setCsvDataItem([]);
        mergeData();
      }

      function mergeData() {
        let tempCustomerData = [];
        let Key = {};
        const newCustomer = [...customerDataRef.current];
        let custId = data.data?.map((item) => item.cust_id);
        const custIdSet = new Set();
        custId?.forEach((id) => custIdSet.add(id));
        custId = Array.from(custIdSet);
        //filter data by cust_id extracted from getGiveawayList() and then merge
        custId.forEach((id) => {
          tempCustomerData = [
            ...tempCustomerData,
            ...newCustomer.filter((item) => {
              let Retain = false;
              if (
                startDate ||
                endDate ||
                criteria.product ||
                criteria.brand ||
                criteria.staffCode
              ) {
                if (item.id === id) {
                  Retain = true;
                }
              } else {
                if (item.id === id || (!item.Sum && !Key[`${item.id}`])) {
                  Key[`${item.id}`] = true;
                  Retain = true;
                }
              }
              return Retain;
            }),
          ];
        });
        setCustomerData(tempCustomerData.sort((cur, next) => cur.id - next.id));
      }
    });
    setTimeout(() => setLoading(false), 1000);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);

      //clear th date in localStorage
      window.localStorage.removeItem("customerManageDate");

      //monitor the page status and it will be triggered to remove the following items when page reloads
      window.addEventListener("beforeunload", () => {
        navigate("", { replace: true });
      });
      //*/

      /*
    1. check if the imcoming route is from page 管理顧客 / 免登記, whose its pathname will be "/customerManage/view/"
    2. if this is the case , clear all the state in last route so that any searching criteria are resetted to null       
    */
      if (
        location.state?.from?.startsWith("/customerManage/view/") ===
          undefined ||
        location.state?.from?.startsWith("/customerManage/view/") === false
      ) {
        navigate("", { replace: true });
      }
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////

      await getAllCustomer()
        .then((data) => {
          if (data && data.results) return data.data;
        })
        .then((cusData) => {
          const data = getGiveawayList(
            {
              brand: null,
              product: null,
              staffCode: null,
            },
            null,
            null
          ).then((giveawayData) => {
            if (giveawayData && giveawayData.results) {
              //merge the returned record from getAllCustomer() with the returned record from getGiveawayList()
              giveawayData.data.forEach((giveawayItem) =>
                cusData.forEach((cusItem) => {
                  if (cusItem.id === giveawayItem.cust_id) {
                    if (cusItem.Sum) {
                      cusItem.Sum.push(giveawayItem);
                    } else {
                      cusItem.Sum = [giveawayItem];
                    }
                  }
                })
              );
            }
            return cusData.map((item) => ({ ...item, Sum: item.Sum?.length }));
          });
          return data;
        })
        .then((data) => {
          let tempArr = [
            {
              fullname: "免登記",
              id: 0,
              phone: "00000000",
              time_created: "1970-01-01T00:00:00Z",
            },
          ];
          if (data) {
            tempArr = [...tempArr, ...data];
            //store merged record into Grid table
            setCustomerData(tempArr);
            //copy merged record to useRef for later re-searching use
            customerDataRef.current = tempArr;
          } else {
            setCustomerData(tempArr);
            customerDataRef.current = tempArr;
          }
        })
        .then(() => {
          /*
        1. check if the state in Route exist in case coming back here from 管理顧客 / 免登記 page
        2. if yes, re-execute fetchGiveawayList() to ensure that still retain the previous stage even thougth enter into 管理顧客 / 免登記 page
          */
          const checkState = () =>
            Date?.startDate ||
            Date?.endDate ||
            criteria?.staffCode ||
            criteria?.brand ||
            criteria?.product
              ? true
              : false;

          checkState() &&
            fetchGiveawayList(criteria).then(() => {
              setTablePage(tablePage);
            });
        });

      //call api to retrieve all Brand name from giveaway master items table
      await getGiveawayMasterItems().then((data) => {
        if (data && data.results) setBrandName(data.data);
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={7}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="管理顧客"
        children={
          actions?.download ? (
            <CSVLink
              data={csvDataItem}
              filename={`Customer Status List - ${moment(startDate).format(
                "YYYY-MM-DD"
              )} to ${moment(endDate).format("YYYY-MM-DD")} `}
              headers={headers}
            >
              <IconButton component="label">
                <DownloadIcon />
              </IconButton>
            </CSVLink>
          ) : null
        }
      />
      <StyledPaper page={"yes"} alignItems="left">
        <ThemeProvider theme={DropDownTheme}>
          <Grid container spacing={2}>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            ></DateSelection>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
      <StyledPaper page={"yes"} alignItems="left">
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              md: 4,
              lg: 4,
            }}
          >
            <ThemeProvider theme={DropDownTheme}>
              <Autocomplete
                value={criteria.brand}
                fullWidth
                options={brandName}
                id="work-select"
                name="work"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                autoSelect
                onChange={(_, data) =>
                  setCriteria((prev) => ({
                    ...prev,
                    brand: data,
                  }))
                }
                getOptionLabel={(option) => option.item_brand}
                renderInput={(params) => (
                  <TextField {...params} label="品牌" sx={{ width: "100%" }} />
                )}
              />
            </ThemeProvider>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 3,
              lg: 3,
            }}
          >
            <ThemeProvider theme={SearchBarTheme}>
              <SearchingBar
                value={criteria.product}
                startAdornment={false}
                clearSearch={() =>
                  setCriteria((prev) => ({
                    ...prev,
                    product: "",
                  }))
                }
                onChange={(event) =>
                  setCriteria((prev) => ({
                    ...prev,
                    product: event.target.value,
                  }))
                }
                placeholder="SKU / 產品名稱"
              />
            </ThemeProvider>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 3,
              lg: 3,
            }}
          >
            <ThemeProvider theme={SearchBarTheme}>
              <SearchingBar
                value={criteria.staffCode}
                startAdornment={false}
                clearSearch={() =>
                  setCriteria((prev) => ({
                    ...prev,
                    staffCode: "",
                  }))
                }
                onChange={(event) =>
                  setCriteria((prev) => ({
                    ...prev,
                    staffCode: event.target.value,
                  }))
                }
                placeholder="員工編號"
              />
            </ThemeProvider>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 2,
              lg: 2,
            }}
          >
            <ThemeProvider theme={ButtonSendTheme}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LoadingButton
                  size="small"
                  onClick={() => {
                    setLoading(true);
                    fetchGiveawayList(criteria);
                  }}
                  endIcon={<SearchOutlinedIcon fontSize="small" />}
                  loading={isLoading}
                  loadingPosition="end"
                  variant="contained"
                >
                  搜尋
                </LoadingButton>
              </div>
            </ThemeProvider>
          </Grid>
        </Grid>
      </StyledPaper>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            onPageChange={(page) => setTablePage(page)}
            page={tablePage}
            rows={customerData.length > 0 ? customerData : []}
            columns={CustomerTableColumn}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
            toolBar={false}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default CustomerManagePage;
